<template>
    <div class="operation">
        <Title chineseTitle="运行监控" englishTitle="operation monitoring and controlling" />
        <div class="operationContent">
            <data-item :data="[
                {
                    key: '有功功率',
                    value: this.$store.state.MQTTObj[deviceName + 'PA'],
                    unit: 'w',
                },{
                    key: 'A相电流',
                    value: this.$store.state.MQTTObj[deviceName + 'Ia'],
                    unit: 'A',
                },]">
            </data-item>
            <data-item :data="[
                {
                    key: '不平衡度',
                    value: this.$store.getters.unbalance(deviceName),
                    unit: '%',
                },{
                    key: 'B相电流',
                    value: this.$store.state.MQTTObj[deviceName + 'Ib'],
                    unit: 'A',
                },]">
            </data-item>
            <data-item :data="[
                {
                    key: '进线母排温度',
                    value: this.$store.state.MQTTObj[deviceName + 'Temperature'],
                    unit: '℃',
                },{
                    key: 'C相电流',
                    value: this.$store.state.MQTTObj[deviceName + 'Ic'],
                    unit: 'A',
                },]">
            </data-item>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";
    import DataItem from "@/components/DataItem";

    export default {
        name: "ParkOperationData",
        components: {
            Title,
            DataItem,
        },
        props: ["projectId"],
        data() {
            return {
                deviceName: ''
            }
        },
        mounted() {
            this.deviceName = this.$store.getters.getOverViewDeviceName(this.projectId)
        }
    };
</script>

<style lang="less" scoped>
    .operation {
        position: fixed;
        top: 880/108vh;
        left: 14600/192vw;
    }

    .operationContent {
        padding-top: 200/108vh;
        width: 4000/192vw;
        height: 1600/108vh;
        background: #030d18;
        opacity: 0.75;
        margin-left: 1vw;
        overflow: hidden;
        display: flex;
        flex-direction: row;
    }
</style>